import type { CreatedAt } from '../../types';


export const DEFAULT_EVALUATIONS_TABLE_COLUMNS = [
  'type_fa',
  'entity_name',
  'outcome_fa',
  'tags_fa',
  'evaluation_token',
  'application_link',
  'timestamp_fa',
  'result_fa',
];

export const DEFAULT_CREATED_AT_FACET: CreatedAt = [[30, 'days'], 'now'];
export const DEFAULT_EVALUATIONS_TABLE_PAGINATE_BY = 20;
export const DEFAULT_TAGS_PAGE_SIZE = 10_000;
export const DEFAULT_EVALUATION_TOKEN_PAGE_SIZE = 50;

// strings starting with L- followed by 20 alphanumeric characters
export const EVALUATION_TOKEN_PATTERN = /L-\w{20}/g;
